module.exports = __webpack_public_path__ + "img/24_53.b8b51ad6.png";